// Bank accounts slice
import { StateCreator, StoreApi } from "zustand";
import { BankAccount } from "@prisma/client";
import { AccountExtended } from "@/types";
import { AppStoreState } from "../appStore";
type SetState = StoreApi<AppStoreState>["setState"];
type GetState = StoreApi<AppStoreState>["getState"];

const createBankAccountsSlice: StateCreator<
  AppStoreState,
  [],
  [],
  Pick<AppStoreState, "bankAccounts" | "setBankAccounts">
> = (set: SetState, get: GetState) => ({
  bankAccounts: [],
  setBankAccounts: (bankAccounts: AccountExtended[] = []) =>
    set({ bankAccounts }),
  addBankAccount: async (account: AccountExtended) => {
    const res = await fetch("/api/bank-accounts", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(account),
    });
    if (!res.ok) throw new Error("Failed to add bank account");
    const user = get().user;
    if (user?.selectedCompany?.id) {
      const accountsRes = await fetch(
        `/api/bank-accounts?companyId=${user.selectedCompany.id}`
      );
      const accountsData = await accountsRes.json();
      set({ bankAccounts: accountsData.bankAccounts || [] });
    }
  },
  updateBankAccount: async (
    accountId: string,
    updates: Partial<AccountExtended>
  ) => {
    const res = await fetch(`/api/bank-accounts/${accountId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updates),
    });
    if (!res.ok) throw new Error("Failed to update bank account");
    const user = get().user;
    if (user?.selectedCompany?.id) {
      const accountsRes = await fetch(
        `/api/bank-accounts?companyId=${user.selectedCompany.id}`
      );
      const accountsData = await accountsRes.json();
      set({ bankAccounts: accountsData.bankAccounts || [] });
    }
  },
  removeBankAccount: async (accountId: string) => {
    const res = await fetch(`/api/bank-accounts/${accountId}`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Failed to remove bank account");
    const user = get().user;
    if (user?.selectedCompany?.id) {
      const accountsRes = await fetch(
        `/api/bank-accounts?companyId=${user.selectedCompany.id}`
      );
      const accountsData = await accountsRes.json();
      set({ bankAccounts: accountsData.bankAccounts || [] });
    }
  },
});

export default createBankAccountsSlice;
